import { Col, DatePicker, Form, Input, Row } from "antd";

const LARGO_MAXIMO = 50;

const requerido = (mensaje) => [
  { required: true, whitespace: true, message: mensaje },
  { max: LARGO_MAXIMO, message: `Máximo ${LARGO_MAXIMO} caracteres` },
];

// Campos que se digitan para cada acta. Se usan al generar y al editar.
export default function DatosActaFields() {
  return (
    <Row gutter={16}>
      <Col xs={24} md={12}>
        <Form.Item
          name="ciudad_expedicion"
          label="Ciudad de expedición de la cédula"
          extra="No está en el registro del participante; se imprime en el acta."
          rules={requerido("Indique la ciudad de expedición")}
        >
          <Input maxLength={LARGO_MAXIMO} />
        </Form.Item>
      </Col>
      <Col xs={24} md={12}>
        <Form.Item
          name="fecha_manifestacion"
          label="Fecha de manifestación"
          rules={[{ required: true, message: "Seleccione la fecha" }]}
        >
          <DatePicker format="DD/MM/YYYY" style={{ width: "100%" }} />
        </Form.Item>
      </Col>
      <Col xs={24} md={12}>
        <Form.Item
          name="telefono_acta"
          label="Teléfono de contacto"
          extra="Solo se ajusta para el acta; el registro del participante no cambia."
          rules={[{ max: 20, message: "Máximo 20 caracteres" }]}
        >
          <Input maxLength={20} />
        </Form.Item>
      </Col>
      <Col xs={24}>
        <Form.Item
          name="nombre_profesional"
          label="Nombre del profesional responsable"
          rules={requerido("Indique el nombre del profesional")}
        >
          <Input maxLength={LARGO_MAXIMO} />
        </Form.Item>
      </Col>
    </Row>
  );
}

export const aDatosActa = (valores) => ({
  ciudad_expedicion: valores.ciudad_expedicion,
  fecha_manifestacion: valores.fecha_manifestacion.format("YYYY-MM-DD"),
  telefono_acta: valores.telefono_acta || "",
  nombre_profesional: valores.nombre_profesional,
});
